/**
 * Strips Quill custom HTML block chrome so only the block's inner content is kept.
 * Used only when sending a custom email so the payload doesn't include editor UI.
 */
export function quillHtmlToEmailBody(quillHtml: string): string {
  if (!quillHtml || typeof quillHtml !== "string") return quillHtml;

  let html = quillHtml;

  while (true) {
    const dataHtmlStart = html.indexOf('data-html="');
    if (dataHtmlStart === -1) break;

    const blockStart = html.lastIndexOf("<div", dataHtmlStart);
    if (blockStart === -1) break;

    const between = html.slice(blockStart, dataHtmlStart);
    if (!between.includes("ql-htmlblock")) break;

    const valueStart = dataHtmlStart + 'data-html="'.length;
    let valueEnd = valueStart;
    let rawValue = "";
    while (valueEnd < html.length) {
      if (html.slice(valueEnd, valueEnd + 6) === "&quot;") {
        rawValue += '"';
        valueEnd += 6;
      } else if (html[valueEnd] === '"') {
        valueEnd += 1;
        break;
      } else {
        rawValue += html[valueEnd];
        valueEnd += 1;
      }
    }

    const inner = decodeHtmlEntities(rawValue);

    const tagEnd = html.indexOf(">", valueEnd);
    if (tagEnd === -1) break;

    let depth = 1;
    let pos = tagEnd + 1;
    let blockEnd = -1;
    while (pos < html.length && depth > 0) {
      const next = html.indexOf("<", pos);
      if (next === -1) break;
      if (html.slice(next, next + 6) === "</div>") {
        depth -= 1;
        if (depth === 0) {
          blockEnd = next + 6; // length of "</div>"
          break;
        }
        pos = next + 6;
      } else if (
        html.slice(next, next + 4) === "<div" &&
        /[\s>]/.test(html[next + 4] ?? "")
      ) {
        depth += 1;
        pos = next + 4;
      } else {
        pos = next + 1;
      }
    }

    if (blockEnd === -1) break;

    html = html.slice(0, blockStart) + inner + html.slice(blockEnd);
  }

  return html;
}

function decodeHtmlEntities(str: string): string {
  return str
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");
}
